/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Info_Rule_BestInputs */

const en_us2_exercise_personal_info_rule_best = /** @type {(inputs: Exercise_Personal_Info_Rule_BestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your best set ever is what counts. A bad day does not bring the number down.`)
};

const pt_br2_exercise_personal_info_rule_best = /** @type {(inputs: Exercise_Personal_Info_Rule_BestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vale a sua melhor série desde sempre. Um dia ruim não faz o número cair.`)
};

const es_419_exercise_personal_info_rule_best = /** @type {(inputs: Exercise_Personal_Info_Rule_BestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta tu mejor serie de siempre. Un mal día no hace bajar el número.`)
};

const pt_pt2_exercise_personal_info_rule_best = /** @type {(inputs: Exercise_Personal_Info_Rule_BestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta a tua melhor série de sempre. Um dia mau não faz o número descer.`)
};

const fr_fr2_exercise_personal_info_rule_best = /** @type {(inputs: Exercise_Personal_Info_Rule_BestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'est ta meilleure série de tous les temps qui compte. Un mauvais jour ne fait pas baisser le chiffre.`)
};

const de_de2_exercise_personal_info_rule_best = /** @type {(inputs: Exercise_Personal_Info_Rule_BestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es zählt dein bester Satz aller Zeiten. Ein schlechter Tag senkt die Zahl nicht.`)
};

const it_it2_exercise_personal_info_rule_best = /** @type {(inputs: Exercise_Personal_Info_Rule_BestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta la tua serie migliore di sempre. Una giornata storta non fa scendere il numero.`)
};

/**
* | output |
* | --- |
* | "Your best set ever is what counts. A bad day does not bring the number down." |
*
* @param {Exercise_Personal_Info_Rule_BestInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_info_rule_best = /** @type {((inputs?: Exercise_Personal_Info_Rule_BestInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Info_Rule_BestInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_info_rule_best(inputs)
	if (locale === "es-419") return es_419_exercise_personal_info_rule_best(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_info_rule_best(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_info_rule_best(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_info_rule_best(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_info_rule_best(inputs)
	return en_us2_exercise_personal_info_rule_best(inputs)
});
export { exercise_personal_info_rule_best as "exercise-personal.info_rule_best" }